<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="container">
        <div class="row">
            <div class="col-12">
                {{message}}
            </div>
        </div>
    </div>
</div>
